<svg
  width="15"
  height="16"
  viewBox="0 0 15 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    d="M1.26 4.79289C1.85429 3.60949 2.76598 2.61469 3.89317 1.91966C5.02035 1.22463 6.31862 0.856761 7.64286 0.857178C9.56786 0.857178 11.185 1.56432 12.4214 2.71789L10.3736 4.76646C9.63286 4.05861 8.69143 3.69789 7.64286 3.69789C5.78214 3.69789 4.20714 4.95504 3.64643 6.64289C3.50357 7.07146 3.42214 7.52861 3.42214 8.00004C3.42214 8.47146 3.50357 8.92861 3.64643 9.35718C4.20786 11.0457 5.78214 12.3022 7.64286 12.3022C8.60357 12.3022 9.42143 12.0486 10.0614 11.62C10.4325 11.3758 10.7501 11.0588 10.9951 10.6882C11.2402 10.3177 11.4076 9.90136 11.4871 9.46432H7.64286V6.70146H14.37C14.4543 7.16861 14.5 7.65575 14.5 8.16218C14.5 10.3379 13.7214 12.1693 12.37 13.4122C11.1886 14.5036 9.57143 15.1429 7.64286 15.1429C6.70474 15.1433 5.77574 14.9588 4.90896 14.5999C4.04218 14.2411 3.25461 13.715 2.59126 13.0516C1.92791 12.3883 1.40178 11.6007 1.04295 10.7339C0.684124 9.86715 0.499625 8.93815 0.500001 8.00004C0.500001 6.84718 0.775715 5.75718 1.26 4.79289Z"
    fill="currentColor"
  />
</svg>
